/**
 * The Play header's content (C2): the bar `index.tsx` renders ABOVE `<Body/>`
 * for the screen D8 took the shell's own header away from. The title is a
 * single string, not a component — once a game owns the Stage (matched /
 * live / evalPending / result) its own player rows and clock already say
 * enough, so the bar stays out of the way and shows nothing there.
 *
 * PHONE ONLY (owner decision, live feedback): `index.tsx` only mounts this
 * unit when `useV2Ui.viewport === 'phone'` — the desktop's permanent drawer
 * sidebar is already an exit control, so no Back (or its leave-game confirm)
 * renders there, and the rail toolbar already carries Sound/Theme. That is
 * also why this model carries no `phone` flag any more: by the time it is
 * mounted at all, it always is.
 */
import {selectRailState} from '@/Store/liveGame/selectors';
import {useLiveGame} from '@/Store/liveGameStore';

import {useBackAction} from '../useBackAction';

/** everything not listed falls through to '' — see the file comment. */
const TITLES: {[railState: string]: string} = {
  home: 'Play',
  seeking: 'Play',
  challengeOut: 'Play',
  tournament: 'Tournament',
  watch: 'Watching',
};

export type PlayHeaderModel = {
  title: string;
  needsConfirm: boolean;
  onBack: () => void;
};

export function usePlayHeaderModel(): PlayHeaderModel {
  const railState = useLiveGame(selectRailState);
  const {needsConfirm, run} = useBackAction();

  return {
    title: TITLES[railState] ?? '',
    needsConfirm,
    onBack: run,
  };
}

export default usePlayHeaderModel;
